import { Flow } from "../interfaces/flow/Flow";
import { TriggerType } from "../interfaces/flow/trigger/TriggerType";
import { LogLevel } from "../interfaces/logging/LogLevel";
import { produce } from "immer";

export const newFlow = (name = "") => {
  return {
    name: name,
    description: "",
    enabled: true,
    actions: [],
    trigger: {
      type: TriggerType.ATLASSIAN_WEBHOOK_TRIGGER_TYPE,
      config: {
        jqlFilter: "",
        events: [],
        projectIds: [],
      },
    },
    logLevel: LogLevel.OFF,
    logRetention: 30,
    metadata: {
      createdBy: "",
      updatedBy: "",
    },
  };
};

export const duplicateFlow = (flow: Flow): Flow => {
  return produce(flow, (draft) => {
    draft.id = undefined;
    draft.name = flow.name + " (copy)";
    draft.enabled = false;
  });
};
